// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__RSksJ","title":"style__title__U-lye","description":"style__description__fYTke","component":"style__component__Gfokv"};